/**
 * Albis brand voice — single source for user-facing role label and shared copy.
 * Rules: docs/albis-voice.md
 */

import { PARENT_MAIL_LABEL } from "./scheduleLabels";

/** English role name; never translate in product copy. */
export const ALBIS_ROLE_LABEL = "Family Manager";

/** Guest first bubble: the miss, not the job title (role stays in the header). */
export const CHAT_WELCOME_GUEST_TEXT =
  "Übersicht verloren und Fristen verpasst in der KiTa- und Schul-E-Mail-Flut?";

export const CHAT_COMPOSER_PLACEHOLDER = "Wähl eine Option";

/** Honest miss — chips stay visible; stay in chat. */
export const CHAT_MISS_TEXT =
  "Das kann ich so nicht zuordnen. Wähl eine Option.";

/** Guest chip «Was steht an?» after the auto-shown demo. */
export const CHAT_GUEST_KITA_DEMO_TEXT =
  "Genau so sieht eine typische Eltern-Mail bei Albis aus:";

/** Guest second bubble: role and what to do, above the demo. */
export const CHAT_GUEST_KITA_BRIDGE_TEXT = `Ich bin euer ${ALBIS_ROLE_LABEL}. Mail weiterleiten oder Foto hochladen. Ich behalte alle Termine im Blick und halte dich auf dem Laufenden! Ausgewählte Termine kannst du mit einem Klick zu deinem persönlichen Kalender hinzufügen.`;

/** Demo row cue — live items open Google Calendar in one tap. */
export const CHAT_DEMO_CALENDAR_HINT = "In den Kalender — mit einem Tipp.";

/** Relief first; setup is a short second beat. */
export const CHAT_GUEST_KITA_CTA_TEXT =
  "Mail weiterleiten oder Flyer fotografieren — ich mache daraus Kalendertermine.";

export const CHAT_GUEST_KITA_CTA_LABEL = "Mit einer Mail starten";

/** Signed-in, no mail yet — ask in the thread, not as a chip. */
export const CHAT_MAIL_SETUP_ASK_TEXT = `Noch nichts gemerkt — soll ich die Adresse holen? Flyer kannst du auch als Foto schicken.`;
export const CHAT_MAIL_SETUP_ASK_ACTION = "Ja, einrichten";

/** Soft CTA after a guest Ferien/Feiertage answer. */
export const CHAT_GUEST_HOLIDAY_SOFT_CTA_TEXT =
  `KiTa-Fristen aus ${PARENT_MAIL_LABEL}s oder Flyern merke ich genauso.`;

export const APP_SHELL_TAGLINE = `Dein ${ALBIS_ROLE_LABEL}`;

/** MVP trust / contact — Mehr footer. */
export const ALBIS_CONTACT_EMAIL = "info@albis.life";
export const ALBIS_ABOUT_LINE = "Zürich";
export const ALBIS_COPYRIGHT_LINE = "© 2026 Albis";

/** For companion / voice backends when wired up. */
export const ALBIS_LLM_VOICE_RULES = [
  "You are Albis, a Family Manager (always write the role as \"Family Manager\" in English; never translate it).",
  "User-facing language is German-first.",
  "Speak as Albis in first person when natural.",
  "Albis is always gender-neutral: no gendered pronouns for yourself; use ich, Albis, or neutral es.",
].join(" ");
